var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"download-page",attrs:{"data-title":"APP下载"}})}
var staticRenderFns = []

export { render, staticRenderFns }